'use client';

import { useState, useEffect } from 'react';
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import HeroButtonDialog from "@/components/home-page/HeroButton";

export default function FullscreenSlider() {
  const [index, setIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const t = useTranslations('tophero');
  const te = useTranslations('Hero');
  const l = useLocale();

  // Get localized field
  const getLocalizedField = (item: any, field: string) => 
    item[`${field}_${l}`] || item[`${field}_en`];

  const slides = [
    {
      id: 4,
      src_en: "/hero-court/padel-court.avif",
      src_ar: "/hero-court/ملعب-بادل.avif",
      src_de: "/hero-court/padel-platz.avif",
      src_es: "/hero-court/pista-de-padel.avif",
      src_fr: "/hero-court/terrain-de-padel.avif",
      src_it: "/hero-court/campo-da-padel.avif",
      src_nl: "/hero-court/padelbaan.avif",
      src_pt: "/hero-court/quadra-de-padel.avif",
      src_ru: "/hero-court/padel-kort.avif",
      src_sv: "/hero-court/padelbana.avif",
      alt: "Padel Court"
    },
    {
      id: 5,
      src_en: "/hero-balls/padel-balls.avif",
      src_ar: "/hero-balls/كرات-بادل.avif",
      src_de: "/hero-balls/padel-baelle.avif",
      src_es: "/hero-balls/bolas-de-padel.avif",
      src_fr: "/hero-balls/balles-de-padel.avif",
      src_it: "/hero-balls/palline-da-padel.avif",
      src_nl: "/hero-balls/padelballen.avif",
      src_pt: "/hero-balls/bolas-de-padel.avif",
      src_ru: "/hero-balls/мячи-падел.avif",
      src_sv: "/hero-balls/padelbollar.avif",
      alt: "Padel Balls"
    },
    {
      id: 6,
      src_en: "/hero-girl/girl-in-padel-court.avif",
      src_ar: "/hero-girl/فتاة-في-ملعب-بادل.avif",
      src_de: "/hero-girl/maedchen-auf-dem-padelplatz.avif",
      src_es: "/hero-girl/chica-en-pista-de-padel.avif",
      src_fr: "/hero-girl/fille-sur-terrain-de-padel.avif",
      src_it: "/hero-girl/ragazza-in-campo-da-padel.avif",
      src_nl: "/hero-girl/meisje-op-padelbaan.avif",
      src_pt: "/hero-girl/menina-em-quadra-de-padel.avif",
      src_ru: "/hero-girl/девушка-на-падел-корте.avif",
      src_sv: "/hero-girl/flicka-pa-padelbana.avif",
      alt: "Girl in Padel Court"
    },
  ];

  // Handle slide change and zoom animation
  useEffect(() => {
    // Reset to normal scale and start zooming immediately
    setZoom(1);
    
    // Start zoom animation immediately for the new slide
    const zoomInterval = setInterval(() => {
      setZoom(prev => {
        if (prev >= 1.1) {
          return 1.1;
        }
        return prev + 0.0007;
      });
    }, 50);

    const slideTimer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => {
      clearInterval(slideTimer);
      clearInterval(zoomInterval);
    };
  }, [index]);

  return (
    <div className="relative w-full  h-[87vh]  overflow-hidden">
      {/* Fixed background section */}
      <div className="fixed top-0 left-0 w-full bg-black h-screen -z-10">
        {/* Image container with zoom effect */}
        <div className="absolute top-0 left-0 w-full bg-black h-full overflow-hidden">
          <Image
            key={slides[index].id}
            src={getLocalizedField(slides[index], "src")}
            alt={slides[index].alt}
            fill
            priority
            className="object-cover"
            style={{
              transform: `scale(${zoom})`,
              transition: 'transform 30ms linear',
              willChange: 'transform'
            }}
            sizes="100vw"
          />
        </div>
        {/* Overlay */}
        <div className="absolute inset-0 bg-a bg-opacity-30"></div>
      </div>

      {/* Fixed content */}
      <div className="w-full h-screen flex items-center justify-center">
        <div className="container mx-2 md:mx-4">
          <div>
            <div>
              <h1 className="text-3xl md:text-5xl lg:text-7xl font-extrabold text-yel py-2 uppercase rounded-lg">
                {t('hero-title')}
              </h1>
              <h2 className="text-2xl custom:text-4xl font-semibold text-white uppercase mb-2">
                {t('hero-title-1')}
              </h2>
              <p className="text-white uppercase max-w-lg">
                {t('hero-description')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer to create scrollable content below */}
      <div className="relative h-screen w-full"></div>
    </div>
  );
}